import { LitElement, html, css, ref, createRef } from '@hh/global.js'

class HHTabs extends LitElement {
  static properties = {
    selectedIndex: { type: Number },
    relativeTrap: { type: String, attribute: 'relative-trap' },
  };

  constructor() {
    super()
    this.selectedIndex = 0
    this.tabsRef = createRef();
    this.contentsRef = createRef();
    this.relativeTrap = ''
  }

  connectedCallback() {
    super.connectedCallback()
    this.tabsRef = createRef();
    this.contentsRef = createRef();
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  firstUpdated() {
    const tabsSlot = this.shadowRoot.querySelector('slot[name="tabs"]');
    const contentsSlot = this.shadowRoot.querySelector('slot[name="contents"]');

    const tabButtons = tabsSlot.assignedElements({ flatten: true }).flatMap(el =>
      Array.from(el.querySelectorAll('.js-tab-tab'))
    )

    const contentSections = contentsSlot.assignedElements({ flatten: true }).flatMap(el =>
      Array.from(el.querySelectorAll('.js-tab-content'))
    )

    if (tabButtons && contentSections) {
      tabButtons.forEach((button, index) => {
        button.addEventListener('click', () => this._selectTab(index, tabButtons, contentSections))
      })
      this._updateContentDisplay(tabButtons, contentSections);
    }
  }

  _selectTab(index, tabButtons, contentSections) {
    this.selectedIndex = index;
    this._updateContentDisplay(tabButtons, contentSections);

    const event = new CustomEvent('hh:content-in-trap:updated', {
      detail: {
        syntax: 'hh-tabs',
        element: this,
        selectedIndex: this.selectedIndex
      },
      bubbles: true,
      composed: true,
    });
    this.dispatchEvent(event);
  }

  _updateContentDisplay(tabButtons, contentSections) {
    tabButtons.forEach((button, index) => {
      button.toggleAttribute('selected', index === this.selectedIndex);
    })

    contentSections.forEach((section, index) => {
      section.classList.toggle('hidden', index !== this.selectedIndex);
      section.toggleAttribute('hidden', index !== this.selectedIndex);
    })
  }

  render() {
    return html`
      <div ${ref(this.tabsRef)}>
        <slot name="tabs"></slot>
      </div>
      <div ${ref(this.contentsRef)}>
        <slot name="contents"></slot>
      </div>
    `
  }

  static styles = css`
    :host {
      display: block;
      width: 100%;
    }

    .hidden {
      display: none;
    }

    ::slotted(.header__submenu-tabs hh-button[selected]) {
      font-weight: bold;
      text-decoration: underline;
    }
  `
}

customElements.define('hh-tabs', HHTabs)
